import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { BodyText, CodeBlock, Image, Quote } from "../slices";
import { prism } from "../styles";

const Content = styled.div`
  ${prism};
  padding: 1rem 0 0 0;
  p,
  li {
    letter-spacing: -0.003em;
    --baseline-multiplier: 0.179;
    --x-height-multiplier: 0.35;
    font-size: 1em;
    line-height: 1.58;
    code {
      padding: 0.2rem 0.5rem;
      margin: 0.5rem 0;
    }
  }
  ul {
    display: flex;
    margin-left: 0;
  }
  ul li {
    list-style: none;
    padding: 0.2em 0.4em;
    background: ${props => props.theme.colors.greyLight};
    color: ${props => props.theme.colors.greyDark};
    border-radius: 4px;
    font-size: 0.8em;
    margin-right: 8px;
  }
  iframe {
    width: 100%;
    height: 50vw;
    max-height: 600px;
  }
  blockquote {
    margin-left: 0;
    padding-left: 1.45rem;
    border-left: 2px solid ${props => props.theme.colors.primary};
    p {
      font-size: 19px;
      font-style: italic;
    }
  }
`;

export default class SliceZone extends Component {
  render() {
    const { allSlices } = this.props;
    const slice = allSlices.map(s => {
      switch (s.slice_type) {
        // These are the API IDs of the slices
        case "text":
          return <BodyText key={s.id} input={s} />;
        case "code_block":
          return <CodeBlock key={s.id} input={s} />;
        case "image":
          return <Image key={s.id} input={s} />;
        case "quote":
          return <Quote key={s.id} input={s} />;
        default:
          return null;
      }
    });
    return <Content>{slice}</Content>;
  }
}

SliceZone.propTypes = {
  allSlices: PropTypes.array.isRequired
};
